// Link & Stack Wholesale theme behaviour: tabs, gallery, filter auto-submit, and the product order grid
// (rows = the non-size option, columns = US sizes) that adds several variants to the cart at once.
(function () {
  const cfg = window.LINKSTACK || {};
  const money = (cents) => "$" + (cents / 100).toFixed(2);
  const RUN_SIZES = ["US 6", "US 7", "US 8", "US 9", "US 10"];

  function initTabs() {
    document.querySelectorAll("[data-tabs]").forEach((group) => {
      group.addEventListener("click", (e) => {
        const b = e.target.closest("button[data-tab]");
        if (!b) return;
        group.querySelectorAll("button").forEach((x) => x.classList.toggle("on", x === b));
        document.querySelectorAll(`[data-pane-of="${group.dataset.tabs}"]`).forEach((p) => { p.hidden = p.dataset.pane !== b.dataset.tab; });
      });
    });
  }

  function initGallery() {
    const main = document.querySelector(".main-img");
    if (!main) return;
    const show = (src) => {
      if (!src) return;
      main.src = src;
      document.querySelectorAll(".thumbs img").forEach((t) => t.classList.toggle("on", t.dataset.full === src));
      document.querySelectorAll(".stone-pick button").forEach((b) => b.classList.toggle("on", b.dataset.src === src));
    };
    document.querySelectorAll(".thumbs img").forEach((t) => t.addEventListener("click", () => show(t.dataset.full)));
    document.querySelectorAll(".stone-pick button").forEach((b) => b.addEventListener("click", () => show(b.dataset.src)));
  }

  function initFilters() {
    const form = document.getElementById("filters");
    if (form) form.addEventListener("change", () => form.submit());
  }

  function initOrderGrid() {
    const table = document.getElementById("order-grid");
    const dataEl = document.getElementById("product-json");
    if (!table || !dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const names = product.options.map((o) => (typeof o === "string" ? o : o.name));
    const sizeIdx = names.indexOf("Size");
    const rowIdx = names.findIndex((n, i) => i !== sizeIdx && n !== "Title");
    const uniq = (arr) => [...new Set(arr)];
    const cols = sizeIdx >= 0 ? uniq(product.variants.map((v) => v.options[sizeIdx])) : ["Qty"];
    const rows = rowIdx >= 0 ? uniq(product.variants.map((v) => v.options[rowIdx])) : [product.title];
    const find = (r, c) => product.variants.find((v) =>
      (rowIdx < 0 || v.options[rowIdx] === r) && (sizeIdx < 0 || v.options[sizeIdx] === c));

    const head = `<thead><tr><th>${rowIdx >= 0 ? names[rowIdx] : ""}</th>${cols.map((c) => `<th>${c.replace("US ", "")}</th>`).join("")}${sizeIdx >= 0 ? "<th></th>" : ""}</tr></thead>`;
    const body = rows.map((r) => {
      const first = find(r, cols[0]) || product.variants.find((v) => rowIdx < 0 || v.options[rowIdx] === r);
      const img = first && first.featured_image ? `<img src="${first.featured_image.src}&width=60" alt="">` : "";
      const cells = cols.map((c) => {
        const v = find(r, c);
        return v ? `<td><input type="number" min="0" value="0" data-id="${v.id}" data-price="${v.price}" data-size="${c}" aria-label="${r} ${c}"></td>` : "<td></td>";
      }).join("");
      const run = sizeIdx >= 0 ? `<td class="run"><button type="button" data-run>+ Run 6–10</button></td>` : "";
      return `<tr><td class="lbl"><span>${img}${rowIdx >= 0 ? r : ""}</span></td>${cells}${run}</tr>`;
    }).join("");
    table.innerHTML = head + `<tbody>${body}</tbody>`;

    const inputs = [...table.querySelectorAll("input")];
    const freeMin = Number(cfg.freeShippingMin || 35) * 100;
    const update = () => {
      let units = 0, total = 0;
      inputs.forEach((i) => {
        const q = Math.max(0, parseInt(i.value, 10) || 0);
        units += q; total += q * Number(i.dataset.price);
        i.classList.toggle("has", q > 0);
      });
      document.getElementById("sum-units").textContent = units;
      document.getElementById("sum-total").textContent = money(total);
      document.getElementById("min-bar").style.width = Math.min(100, (total / freeMin) * 100) + "%";
      const left = freeMin - total;
      document.getElementById("min-text").textContent = left > 0
        ? `Add ${money(left)} more, in any styles, for free shipping ($${cfg.flatShipping} flat rate below $${freeMin / 100})`
        : "This selection ships free";
    };
    table.addEventListener("click", (e) => {
      const b = e.target.closest("button[data-run]");
      if (!b) return;
      b.closest("tr").querySelectorAll("input").forEach((i) => {
        if (RUN_SIZES.includes(i.dataset.size)) i.value = (parseInt(i.value, 10) || 0) + 1;
      });
      update();
    });
    table.addEventListener("input", update);
    update();

    const status = document.getElementById("add-status");
    document.getElementById("add-grid").addEventListener("click", async () => {
      const items = inputs.map((i) => ({ id: Number(i.dataset.id), quantity: parseInt(i.value, 10) || 0 })).filter((x) => x.quantity > 0);
      if (!items.length) { status.textContent = "Enter a quantity for at least one size."; return; }
      status.textContent = "Adding…";
      try {
        const res = await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
        if (!res.ok) throw new Error((await res.json()).description || res.statusText);
        window.location.href = "/cart";
      } catch (err) {
        status.textContent = "Couldn't add to cart: " + err.message;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initTabs();
    initGallery();
    initFilters();
    initOrderGrid();
  });
})();
